// Umami Analytics Utility for SPA virtual pageview tracking

declare global {
  interface Window {
    umami?: {
      track: ((payload: (props: Record<string, unknown>) => Record<string, unknown>) => void) &
             ((eventName: string, eventData?: Record<string, string | number>) => void);
    };
  }
}

// Map AppView enum values to URL paths and page titles
const VIEW_TO_PAGE: Record<string, { url: string; title: string }> = {
  LANDING: { url: '/', title: 'Landing' },
  QUIZ: { url: '/quiz', title: 'Quiz' },
  DASHBOARD: { url: '/dashboard', title: 'Dashboard' },
  MAP: { url: '/map', title: 'Map Explorer' },
  NEIGHBORHOODS: { url: '/neighborhoods', title: 'Neighborhoods' },
  SCHOOLS: { url: '/schools', title: 'Schools' },
  CHECKLIST: { url: '/checklist', title: 'Checklist' },
  INVESTMENTS: { url: '/investments', title: 'Investments' },
  COMMUNITY: { url: '/community', title: 'Community Q&A' },
};

// Track virtual pageview for SPA navigation
export const trackPageView = (viewName: string) => {
  if (typeof window === 'undefined' || !window.umami) return;

  const page = VIEW_TO_PAGE[viewName];
  if (page) {
    window.umami.track((props) => ({
      ...props,
      url: page.url,
      title: page.title,
    }));
  }
};

// Track custom events
export const trackEvent = (eventName: string, eventData?: Record<string, string | number>) => {
  if (typeof window !== 'undefined' && window.umami) {
    window.umami.track(eventName, eventData);
  }
};
